import React from 'react';
import { useAppSelector } from '../../../contexts/hooks';
import { useScreenSize } from '../../../utils/media-query';

interface CheckPermissionsProps {
  permissions: string | null;
  status: boolean; // Prop para indicar si el componente está activo o no
  columns?: 'one' | 'two' | 'three' | 'four'; // Nueva prop opcional
  children: React.ReactNode;
}

export const CheckPermissions: React.FC<CheckPermissionsProps> = ({ permissions, status, columns = 1, children }) => {
  const idProfile = useAppSelector((x) => x.userInfo.User?.Us_Pe_Id);
  const { isSmall, isXSmall } = useScreenSize();

  if (!permissions || !idProfile || !status) {
    return null; // Si no hay permisos o no hay ID de perfil, no renderiza nada
  }

  const allowedPermissions = permissions.split(',').map((perm) => perm.trim());
  const hasPermission = allowedPermissions.includes(idProfile.toString());

  if (!hasPermission && !permissions.includes('-1')) return null;
  if (isSmall || isXSmall) {
    columns = 'one'; // Si es pantalla pequeña, forzamos a una columna
  }

  const columnClass = `${columns}-columns`; // Ej: 1-column, 2-columns

  return <div className={`${columnClass}`}>{children}</div>;
};
